import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import SearchChatBox from './SearchChatbox';
import './Chat.css';
import ChatBox from './ChatBox';
import { useModuleContext } from '../../context/ModuleProvider';
import { useAuthContext } from '../../context/AuthContextProvider';
import axiosInstance from '../../axiosapi';

const AskTeacher = () => {
  const { currentUser } = useAuthContext();
  const { serverUrl, url } = useModuleContext();
  const [teacherList, setTeacherList] = useState([]);
  const [showPanel, setShowPanel] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [selectedTeacher, setSelectedTeacher] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [teachers, setTeachers] = useState([]);

  const fetchTeachers = async () => {
    try {
      const response = await axiosInstance.get(`${url}/teacher/teacher`);
      setTeacherList(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchTeachers();
  }, []);

  const fetchChats = async () => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.get(`${serverUrl}/messages/teacher-list?studentId=${currentUser.id}`);
      setTeachers(response.data.data.filter((data) => data.id !== currentUser.id));
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    if (currentUser) {
      fetchChats();
    }
  }, [currentUser]);

  return (
    <>
      <div onClick={() => setShowPanel(false)} className="chat-container">
        {/* Sidebar */}
        <div className="chat-sidebar">
          <h2 className="chat-title">All Messages</h2>

          <div className="search-box">
            <SearchChatBox
              showPanel={showPanel}
              setShowPanel={setShowPanel}
              searchText={searchValue}
              setSearchText={setSearchValue}
              teacherList={teacherList}
              isLoading={isLoading}
              setSelectedTeacher={setSelectedTeacher}
            />
          </div>
          <hr />
          <Sidebar sidebarData={teachers} selectedTeacher={selectedTeacher} setSelectedTeacher={setSelectedTeacher} />
        </div>
        {/* {selectedTeacher && ( */}
        <ChatBox
          key={currentUser.id}
          selectedStudent={currentUser}
          selectedTeacher={selectedTeacher}
          onSuccess={() => {
            fetchChats();
          }}
        />
        {/* // )} */}
      </div>
    </>
  );
};

export default AskTeacher;
